import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { CpCompareTimeRangeService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-header/cp-compare-timerange/cp-compare-timerange.service';
import { CPCompareSidebarCacheService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar-cache.service';
import { CpCompareSidebarCardsService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar-cards.service';
import { CpCompareSidebarService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cp-compare-sidebar',
  templateUrl: './cp-compare-sidebar.component.html',
  styleUrls: ['./cp-compare-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpCompareSidebarComponent {

  private sub = new Subscription();

  constructor(
    private compareTimeRangeService: CpCompareTimeRangeService,
    private compareSidebarService: CpCompareSidebarService,
    private compareSidebarCardsService: CpCompareSidebarCardsService,
    private compareSidebarCacheService: CPCompareSidebarCacheService,
    private homesFacade: HomesFacade,
  ) {}

  async ngOnInit() {
    this.sub.add(this.compareSidebarCardsService.measureCards$.subscribe(async () => {
      const measureCards = await this.compareSidebarCacheService.getCacheMeasureCards();
      this.compareSidebarService.selectCards(measureCards);
    }));

    // When we compare 2 timeranges the maximum of select cards becomes 2
    // otherwise it's 4
    this.sub.add(
      this.compareTimeRangeService.secondTimeRange$.subscribe(timeRange => {
        if (timeRange) {
          this.compareSidebarService.setMaxCards(2);
        }
        else {
          this.compareSidebarService.setMaxCards(4);
        }
      })
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
